// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__1JJ9Y","consent":"style_consent__3mAr4","button":"style_button__1O8jB"};